import React, { useState, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";
import shuffle from "lodash/shuffle";
import round from "lodash/round";
import styled from "styled-components";
import Answer from "./Answer";

const Container = styled.div`
  width: 100%;
  max-width: 90rem;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: ${(props) => 3.5 * props.fontSizeMultiplier}rem;

  @media (min-width: 768px) {
    margin-bottom: 2rem;
    font-size: ${(props) => 5 * props.fontSizeMultiplier}rem;
  }
`;

const Text = styled.p`
  margin-bottom: 2rem;
  font-size: ${(props) => 2.2 * props.fontSizeMultiplier}rem;

  @media (min-width: 768px) {
    margin-bottom: 4rem;
    font-size: ${(props) => 3 * props.fontSizeMultiplier}rem;
  }
`;

const List = styled.ol`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1.5rem;
`;

const ListItem = styled.li`
  display: block;
  padding: 0 1rem 2rem;
  flex: ${(props) =>
    props.columns > 2 && props.answers > 3 ? "0 1 50%" : "1 1 100%"};
  max-width: ${(props) =>
    props.columns > 2 && props.answers > 3 ? "50%" : "100%"};

  @media (min-width: 640px) {
    padding: 0 1.5rem 3rem;
    flex-grow: ${(props) => (props.columns === 1 ? 1 : 0)};
    max-width: ${(props) => round(100 / props.columns, 2)}%;
    flex-basis: ${(props) => round(100 / props.columns, 2)}%;
  }
`;

const Question = (props) => {
  const [loading, setLoading] = useState(false);

  const answers = useMemo(
    () => (props.random ? shuffle(props.answers) : props.answers),
    [props.answers]
  );

  const answersCount = answers.length + (props.other ? 1 : 0);

  return (
    <Container>
      <Title
        fontSizeMultiplier={
          props.title.length > 75 ? 75 / props.title.length : 1
        }
      >
        {props.title}
      </Title>
      <Text
        fontSizeMultiplier={
          props.text.length > 130 ? 130 / props.text.length : 1
        }
      >
        {props.text}
      </Text>

      <List>
        {answers.map((answer) => (
          <ListItem
            columns={props.columns}
            answers={answersCount}
            key={answer.id === "other" ? uuidv4() : `answer-${answer.id}`}
          >
            <Answer
              {...answer}
              columns={props.columns}
              multiChoice={props.multiChoice}
              dispatch={props.dispatch}
              answer={props.answer}
              loading={loading}
              setLoading={setLoading}
              isWeighted={props.weightedBudget}
              noBudget={props.noBudget}
            />
          </ListItem>
        ))}

        {props.other && (
          <ListItem columns={props.columns} answers={answersCount}>
            <Answer
              key={uuidv4()}
              id="other"
              type="text"
              title="Other"
              columns={props.columns}
              multiChoice={props.multiChoice}
              dispatch={props.dispatch}
              answer={props.answer}
              loading={loading}
              setLoading={setLoading}
            />
          </ListItem>
        )}
      </List>
    </Container>
  );
};

export default Question;
